import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
import PublicLayout from "@/views/Pages/PublicLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// Example pages
import UserProfile from "@/views/Examples/UserProfile.vue";
import ListRolePage from "@/views/Examples/RoleManagement/ListRolePage.vue";
import EditRolePage from "@/views/Examples/RoleManagement/EditRolePage.vue";
import AddRolePage from "@/views/Examples/RoleManagement/AddRolePage.vue";
import ListUserPage from "@/views/Examples/UserManagement/ListUserPage.vue";
import EditUserPage from "@/views/Examples/UserManagement/EditUserPage.vue";
import AddUserPage from "@/views/Examples/UserManagement/AddUserPage.vue";
import ListEmployeePage from "@/views/Examples/UserManagement/ListEmployeePage.vue";

// Tag Management
import ListTagPage from "@/views/Examples/TagManagement/ListTagPage.vue";
import EditTagPage from "@/views/Examples/TagManagement/EditTagPage";
import AddTagPage from "@/views/Examples/TagManagement/AddTagPage.vue";
// Item Management
import ListItemPage from "@/views/Examples/ItemManagement/ListItemPage.vue";
import AddItemPage from "@/views/Examples/ItemManagement/AddItemPage.vue";
import EditItemPage from "@/views/Examples/ItemManagement/EditItemPage";

// Empresa Management
import ListEmpresaPage from "@/views/Examples/EmpresaManagement/ListEmpresaPage.vue";
import EditEmpresaPage from "@/views/Examples/EmpresaManagement/EditEmpresaPage";
import AddEmpresaPage from "@/views/Examples/EmpresaManagement/AddEmpresaPage.vue";
//Categorias Management
import ListCategoryPage from "@/views/Examples/CategoryManagement/ListCategoryPage.vue";
import EditCategoryPage from "@/views/Examples/CategoryManagement/EditCategoryPage.vue";
import AddCategoryPage from "@/views/Examples/CategoryManagement/AddCategoryPage.vue";
import ListDivisionPage from "@/views/Examples/CategoryManagement/ListDivisionPage.vue";
import ListTipoPage from "@/views/Examples/CategoryManagement/ListTipoPage.vue";
import ListSubtipoPage from "@/views/Examples/CategoryManagement/ListSubtipoPage.vue";
// Activo Management
import ListActivoPage from "@/views/Examples/ActivoManagement/ListActivoPage.vue";
import EditActivoPage from "@/views/Examples/ActivoManagement/EditActivoPage";
import AddActivoPage from "@/views/Examples/ActivoManagement/AddActivoPage.vue";
import ViewActivoPage from "@/views/Examples/ActivoManagement/ViewActivoPage";
import ViewDispAnclajePage from "../views/Examples/ActivoManagement/ViewDispAnclajePage.vue";
//import ViewActivoPublicPage from "@/views/Examples/ActivoManagement/ViewActivoPublicPage";
import ListHerramientaPage from "../views/Examples/ActivoManagement/ListHerramientaPage";
import ListEPIPage from "@/views/Examples/ActivoManagement/ListEPIPage";
import ListDispAnclajePage from "../views/Examples/ActivoManagement/ListDispAnclajePage.vue";
import ListRetiradosPage from "../views/Examples/ActivoManagement/ListRetiradosPage.vue";
import ListFinVidaUtilPage from "../views/Examples/ActivoManagement/ListFinVidaUtilPage.vue";

// Fabricante Management
import ListFabricantesPage from "@/views/Examples/FabricantesManagement/ListFabricantesPage.vue";
import EditFabricantesPage from "@/views/Examples/FabricantesManagement/EditFabricantesPage";
import AddFabricantesPage from "@/views/Examples/FabricantesManagement/AddFabricantesPage.vue";

// Modelos Management
import ListModelosPage from "@/views/Examples/ModelosManagement/ListModelosPage.vue";
import EditModelosPage from "@/views/Examples/ModelosManagement/EditModelosPage";
import AddModelosPage from "@/views/Examples/ModelosManagement/AddModelosPage.vue";
import VidaUtilModelosPage from "@/views/Examples/ModelosManagement/VidaUtilModelosPage.vue";

// Revision Management
import ListRevisionPage from "@/views/Examples/RevisionManagement/ListRevisionPage.vue";
import EditRevisionPage from "@/views/Examples/RevisionManagement/EditRevisionPage";
import AddRevisionPage from "@/views/Examples/RevisionManagement/AddRevisionPage.vue";

// Tarea Management
import ListTareaPage from "@/views/Examples/TareaManagement/ListTareaPage.vue";
import EditTareaPage from "@/views/Examples/TareaManagement/EditTareaPage";
import AddTareaPage from "@/views/Examples/TareaManagement/AddTareaPage.vue";

// Incidencia Management
import ListIncidenciaPage from "@/views/Examples/IncidenciaManagement/ListIncidenciaPage.vue";
import EditIncidenciaPage from "@/views/Examples/IncidenciaManagement/EditIncidenciaPage";
import AddIncidenciaPage from "@/views/Examples/IncidenciaManagement/AddIncidenciaPage.vue";
import ViewIncidenciaPage from "@/views/Examples/IncidenciaManagement/ViewIncidenciaPage.vue";

// Notificacion Management
import ListNotificacionPage from "@/views/Examples/NotificacionManagement/ListNotificacionPage.vue";
import ListNotificacionEnviadaPage from "@/views/Examples/NotificacionManagement/ListNotificacionEnviadaPage.vue";
import EditNotificacionPage from "@/views/Examples/NotificacionManagement/EditNotificacionPage";
import AddNotificacionPage from "@/views/Examples/NotificacionManagement/AddNotificacionPage.vue";
import AddNotificacionToUserPage from "@/views/Examples/NotificacionManagement/AddNotificacionToUserPage";

// Calendar
const Calendar = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Calendar/Calendar.vue");
// Charts
const Charts = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Charts.vue");

// Components pages
const Buttons = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Buttons.vue");
const Cards = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Cards.vue");
const GridSystem = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/GridSystem.vue"
  );
const Notifications = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/Notifications.vue"
  );
const Icons = () =>
  import(/* webpackChunkName: "components" */ "@/views/Components/Icons.vue");
const Typography = () =>
  import(
    /* webpackChunkName: "components" */ "@/views/Components/Typography.vue"
  );

// Dashboard pages
const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Dashboard/Dashboard.vue");
const AlternativeDashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "@/views/Dashboard/AlternativeDashboard.vue"
  );
const Widgets = () =>
  import(/* webpackChunkName: "dashboard" */ "@/views/Widgets.vue");

// Forms pages
const FormElements = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormElements.vue");
const FormComponents = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormComponents.vue");
const FormValidation = () =>
  import(/* webpackChunkName: "forms" */ "@/views/Forms/FormValidation.vue");

// Maps pages
const GoogleMaps = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Maps/GoogleMaps.vue");
const VectorMaps = () =>
  import(/* webpackChunkName: "extra" */ "@/views/Maps/VectorMaps.vue");

// Pages
const User = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile.vue");
const Pricing = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Pricing.vue");
const TimeLine = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/TimeLinePage.vue");
const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");
const Register = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Register.vue");
const Lock = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Lock.vue");

const ViewActivoPublicPage = () =>
  import(
    /* webpackChunkName: "pages" */ "@/views/Examples/ActivoManagement/ViewActivoPublicPage.vue"
  );

const PasswordReset = () =>
  import(/* webpackChunkName: "password" */ "@/views/Password/Reset.vue");
const PasswordEmail = () =>
  import(/* webpackChunkName: "password" */ "@/views/Password/Email.vue");

// TableList pages
const RegularTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/RegularTables.vue");
const SortableTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/SortableTables.vue");
const PaginatedTables = () =>
  import(/* webpackChunkName: "tables" */ "@/views/Tables/PaginatedTables.vue");

//import middleware
import auth from "@/middleware/auth";
import guest from "@/middleware/guest";
import admin from "@/middleware/admin";
import admin_creator from "@/middleware/admin_creator";
import ListHerramientasPage from "../views/Examples/ActivoManagement/ListHerramientaPage.vue";

// Albaran Management
import ListAlbaranPage from "@/views/Examples/AlbaranManagement/ListAlbaranPage.vue";
import ViewAlbaranPage from "@/views/Examples/AlbaranManagement/ViewAlbaranPage.vue";
import ListIncidenciaAlbaranPage from "@/views/Examples/AlbaranManagement/ListIncidenciaAlbaranPage.vue";

// Keikaku
import KeikakuPage from "@/views/Examples/Keikaku/KeikakuPage.vue";

// Poal
import PoalPage from "@/views/Examples/Poal/PoalPage.vue";
import PartesPage from "@/views/Examples/Partes/PartesPage.vue";
import ViewPartePage from "@/views/Examples/Partes/ViewPartePage.vue";

import ListInspeccionVisualPage from "@/views/Examples/InspeccionVisual/ListInspeccionVisualPage.vue";
import ViewInspeccionVisualPage from "@/views/Examples/InspeccionVisual/ViewInspeccionVisualPage.vue";

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      component: Buttons,
    },
    {
      path: "cards",
      name: "Cards",
      component: Cards,
    },
    {
      path: "grid-system",
      name: "Grid System",
      component: GridSystem,
    },
    {
      path: "notifications",
      name: "Notifications",
      component: Notifications,
    },
    {
      path: "icons",
      name: "Icons",
      component: Icons,
    },
    {
      path: "typography",
      name: "Typography",
      component: Typography,
    },
  ],
};
let examplesMenu = {
  path: "/",
  component: DashboardLayout,
  name: "Examples",
  children: [
    {
      path: "user-profile",
      name: "User Profile",
      components: { default: UserProfile },
      meta: { middleware: auth },
    },
    {
      path: "role-management/list-roles",
      name: "List Roles",
      components: { default: ListRolePage },
      meta: { middleware: admin },
    },
    {
      path: "role-management/add-role",
      name: "Add Role",
      components: { default: AddRolePage },
      meta: { middleware: admin },
    },
    {
      path: "role-management/edit-role/:id",
      name: "Edit Role",
      components: { default: EditRolePage },
      meta: { middleware: admin },
    },
    {
      path: "user-management/list-users",
      name: "List Users",
      components: { default: ListUserPage },
      meta: { middleware: admin },
    },
    {
      path: "user-management/list-employees",
      name: "List Employees",
      components: { default: ListEmployeePage },
      meta: { middleware: admin },
    },
    {
      path: "inspeccion-visual/list",
      name: "List Inspeccion Visual",
      components: { default: ListInspeccionVisualPage },
      meta: { middleware: auth },
    },
    {
      path: "inspeccion-visual/view/:id",
      name: "View Inspeccion Visual",
      components: { default: ViewInspeccionVisualPage },
      meta: { middleware: auth },
    },
    {
      path: "user-management/add-user",
      name: "Add User",
      components: { default: AddUserPage },
      meta: { middleware: admin },
    },
    {
      path: "user-management/edit-user/:id",
      name: "Edit User",
      components: { default: EditUserPage },
      meta: { middleware: admin },
    },
    {
      path: "tag-management/list-tags",
      name: "List Tags",
      components: { default: ListTagPage },
      meta: { middleware: admin_creator },
    },
    {
      path: "tag-management/add-tag",
      name: "Add Tag",
      components: { default: AddTagPage },
      meta: { middleware: admin_creator },
    },
    {
      path: "tag-management/edit-tag/:id",
      name: "Edit Tag",
      components: { default: EditTagPage },
      meta: { middleware: admin_creator },
    },
    {
      path: "fabricante-management/list-fabricantes",
      name: "List Fabricantes",
      components: { default: ListFabricantesPage },
      meta: { middleware: auth },
    },
    {
      path: "fabricante-management/add-fabricantes",
      name: "Add Fabricantes",
      components: { default: AddFabricantesPage },
      meta: { middleware: auth },
    },
    {
      path: "fabricante-management/edit-fabricantes/:id",
      name: "Edit Fabricantes",
      components: { default: EditFabricantesPage },
      meta: { middleware: auth },
    },
    {
      path: "modelo-management/list-modelos",
      name: "List Modelos",
      components: { default: ListModelosPage },
      meta: { middleware: auth },
    },
    {
      path: "modelo-management/add-modelos",
      name: "Add Modelos",
      components: { default: AddModelosPage },
      meta: { middleware: auth },
    },
    {
      path: "modelo-management/edit-modelos/:id",
      name: "Edit Modelos",
      components: { default: EditModelosPage },
      meta: { middleware: auth },
    },
    {
      path: "modelo-management/vida-util-modelos",
      name: "Vida Util Modelos",
      components: { default: VidaUtilModelosPage },
      meta: { middleware: auth },
    },
    {
      path: "empresa-management/list-empresa",
      name: "List Empresa",
      components: { default: ListEmpresaPage },
      meta: { middleware: auth },
    },
    {
      path: "empresa-management/add-empresa",
      name: "Add Empresa",
      components: { default: AddEmpresaPage },
      meta: { middleware: auth },
    },
    {
      path: "empresa-management/edit-empresa/:id",
      name: "Edit Empresa",
      components: { default: EditEmpresaPage },
      meta: { middleware: auth },
    },
    {
      path: "category-management/list-categories",
      name: "List Categories",
      components: { default: ListCategoryPage },
      meta: { middleware: admin_creator },
    },
    {
      path: "category-management/add-category",
      name: "Add Category",
      components: { default: AddCategoryPage },
      meta: { middleware: admin_creator },
    },
    {
      path: "category-management/edit-category/:id",
      name: "Edit Category",
      components: { default: EditCategoryPage },
      meta: { middleware: admin_creator },
    },
    {
      path: "category-management/list-divisiones",
      name: "List Division",
      components: { default: ListDivisionPage },
      meta: { middleware: admin_creator },
    },
    {
      path: "category-management/list-tipos",
      name: "List Tipos",
      components: { default: ListTipoPage },
      meta: { middleware: admin_creator },
    },
    {
      path: "category-management/list-subtipos",
      name: "List Subtipos",
      components: { default: ListSubtipoPage },
      meta: { middleware: admin_creator },
    },
    {
      path: "activo-management/list-activos",
      name: "List Activo",
      components: { default: ListActivoPage },
      meta: { middleware: auth },
    },
    {
      path: "activo-management/list-herramientas",
      name: "List Herramienta",
      components: { default: ListHerramientaPage },
      meta: { middleware: auth },
    },
    {
      path: "activo-management/list-epis",
      name: "List Epi",
      components: { default: ListEPIPage },
      meta: { middleware: auth },
    },
    {
      path: "activo-management/list-anclaje",
      name: "List Anclaje",
      components: { default: ListDispAnclajePage },
      meta: { middleware: auth },
    },
    {
      path: "activo-management/list-fin-vida-util",
      name: "List Fin Vida Util",
      components: { default: ListFinVidaUtilPage },
      meta: { middleware: auth },
    },
    {
      path: "activo-management/list-retirados",
      name: "List Retirado",
      components: { default: ListRetiradosPage },
      meta: { middleware: auth },
    },
    {
      path: "activo-management/add-activo",
      name: "Add Activo",
      components: { default: AddActivoPage },
      meta: { middleware: auth },
    },
    {
      path: "activo-management/edit-activo/:id",
      name: "Edit Activo",
      components: { default: EditActivoPage },
      meta: { middleware: auth },
    },
    {
      path: "activo-management/view-activo/:id",
      name: "View Activo",
      components: { default: ViewActivoPage },
      meta: { middleware: auth },
    },
    {
      path: "activo-management/view-anclaje/:id",
      name: "View Anclaje",
      components: { default: ViewDispAnclajePage },
      meta: { middleware: auth },
    },
    {
      path: "revision-management/list-revisiones",
      name: "List Revision",
      components: { default: ListRevisionPage },
      meta: { middleware: auth },
    },
    {
      path: "revision-management/add-activo",
      name: "Add Revision",
      components: { default: AddRevisionPage },
      meta: { middleware: auth },
    },
    {
      path: "revision-management/edit-revision/:id",
      name: "Edit Revision",
      components: { default: EditRevisionPage },
      meta: { middleware: auth },
    },
    {
      path: "tarea-management/list-tareas",
      name: "List Tarea",
      components: { default: ListTareaPage },
      meta: { middleware: auth },
    },
    {
      path: "tarea-management/add-tarea",
      name: "Add Tarea",
      components: { default: AddTareaPage },
      meta: { middleware: auth },
    },
    {
      path: "tarea-management/edit-tarea/:id",
      name: "Edit Tarea",
      components: { default: EditTareaPage },
      meta: { middleware: auth },
    },

    {
      path: "incidencia-management/list-incidencias",
      name: "List incidencias",
      components: { default: ListIncidenciaPage },
      meta: { middleware: auth },
    },
    {
      path: "incidencia-management/add-incidencia",
      name: "Add incidencia",
      components: { default: AddIncidenciaPage },
      meta: { middleware: auth },
    },
    {
      path: "incidencia-management/edit-incidencia/:id",
      name: "Edit incidencia",
      components: { default: EditIncidenciaPage },
      meta: { middleware: auth },
    },
    {
      path: "incidencia-management/view-incidencia/:id",
      name: "View incidencia",
      components: { default: ViewIncidenciaPage },
      meta: { middleware: auth },
    },
    {
      path: "notificacion-management/list-notificaciones",
      name: "List notificaciones",
      components: { default: ListNotificacionPage },
      meta: { middleware: auth },
    },
    {
      path: "notificacion-management/list-notificaciones-enviadas",
      name: "List notificaciones enviadas",
      components: { default: ListNotificacionEnviadaPage },
      meta: { middleware: auth },
    },
    {
      path: "notificacion-management/add-notificacion",
      name: "Add notificacion",
      components: { default: AddNotificacionPage },
      meta: { middleware: auth },
    },
    {
      path: "notificacion-management/add-notificacion-to-user",
      name: "Add notificacion to user",
      components: { default: AddNotificacionToUserPage },
      meta: { middleware: auth },
    },
    {
      path: "notificacion-management/edit-notificacion/:id",
      name: "Edit notificacion",
      components: { default: EditNotificacionPage },
      meta: { middleware: auth },
    },

    {
      path: "item-management/list-items",
      name: "List Items",
      components: { default: ListItemPage },
      meta: { middleware: auth },
    },
    {
      path: "item-management/add-item",
      name: "Add Item",
      components: { default: AddItemPage },
      meta: { middleware: auth },
    },
    {
      path: "item-management/edit-item/:id",
      name: "Edit Item",
      components: { default: EditItemPage },
      meta: { middleware: auth },
    },
    {
      path: "albaran-management/list-albaranes",
      name: "List Albaran",
      components: { default: ListAlbaranPage },
      meta: { middleware: auth },
    },
    {
      path: "partes",
      name: "Partes",
      components: { default: PartesPage },
      meta: { middleware: auth },
    },
    {
      path: "partes/:id",
      name: "View Parte",
      components: { default: ViewPartePage },
      meta: { middleware: auth },
    },
    {
      path: "albaran-management/add-albaran",
      name: "Add Albaran",
      components: { default: () => import("@/views/Examples/AlbaranManagement/AddAlbaranPage.vue") },
      meta: { middleware: auth },
    },
    {
      path: "albaran-management/view-albaran/:id",
      name: "View Albaran",
      components: { default: ViewAlbaranPage },
      meta: { middleware: auth },
    },
    {
      path: "albaran-management/stats",
      name: "Albaran Stats",
      components: { default: () => import("@/views/Examples/AlbaranManagement/AlbaranStatsPage.vue") },
      meta: { middleware: auth },
    },
    {
      path: "albaran-management/incidencias-albaranes",
      name: "List Incidencia Albaran",
      components: { default: ListIncidenciaAlbaranPage },
      meta: { middleware: auth },
    },
    {
      path: "keikaku",
      name: "Keikaku",
      components: { default: KeikakuPage },
      meta: { middleware: auth, hideFooter: true },
    },
    {
      path: "poal",
      name: "Poal",
      components: { default: PoalPage },
      meta: { middleware: auth },
    },
  ],
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/elements",
  name: "Forms",
  children: [
    {
      path: "elements",
      name: "Form elements",
      component: FormElements,
    },
    {
      path: "components",
      name: "Form components",
      component: FormComponents,
    },
    {
      path: "validation",
      name: "Form validation",
      component: FormValidation,
    },
  ],
};

let tablesMenu = {
  path: "/tables",
  component: DashboardLayout,
  redirect: "/table/regular",
  name: "Tables menu",
  children: [
    {
      path: "regular",
      name: "Tables",
      component: RegularTables,
    },
    {
      path: "sortable",
      name: "Sortable",
      component: SortableTables,
    },
    {
      path: "paginated",
      name: "Paginated Tables",
      component: PaginatedTables,
    },
  ],
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      component: GoogleMaps,
    },
    {
      path: "vector",
      name: "Vector Map",
      component: VectorMaps,
    },
  ],
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      component: User,
    },
    {
      path: "timeline",
      name: "Timeline Page",
      component: TimeLine,
    },
  ],
};

let publicPages = {
  path: "/",
  component: PublicLayout,
  name: "Public",
  children: [
    {
      path: "/code/:code",
      name: "View Activo Public Page",
      component: ViewActivoPublicPage,
    },
  ],
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { middleware: guest },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: { middleware: guest },
    },
    {
      path: "/password/reset",
      name: "PasswordReset",
      component: PasswordReset,
      meta: { middleware: guest },
    },
    {
      path: "/password/email",
      name: "PasswordEmail",
      component: PasswordEmail,
      meta: { middleware: guest },
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing,
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock,
    },
  ],
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
  },
  componentsMenu,
  examplesMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  {
    path: "/",
    component: DashboardLayout,
    name: "Dashboard layout",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: { middleware: auth },
      },
      {
        path: "alternative",
        name: "Alternative",
        component: AlternativeDashboard,
        meta: {
          navbarType: "light",
        },
      },
      {
        path: "calendar",
        name: "Calendar",
        component: Calendar,
      },
      {
        path: "charts",
        name: "Charts",
        component: Charts,
      },
      {
        path: "widgets",
        name: "Widgets",
        component: Widgets,
      },
    ],
  },
  authPages,
  publicPages,
];

export default routes;
